<template>
  <div>
    <Loader no-axios>
      <div v-if="!lodash.isEmpty(filterColumns)" class="row"></div>
      <div class="row">
        <model-index
          ref="table"
          class="col-12"
          :loading="loading || updating"
          v-bind="$props"
          :columns="columns"
          :busy.sync="busy"
          :models-paginated="modelsPaginated"
          :page.sync="page"
          :per-page.sync="perPage"
          :from="from"
          :total="totalFiltered"
          :search.sync="search"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :filter-params.sync="filterParams"
          @create-click="handleCreate"
          @export-click="handleExport"
          @show-click="handleShow"
          @edit-click="handleEdit"
          @delete-click="handleDelete"
        >
          <template #card-title="{}">
            <div class="d-flex justify-content-between">
              <div class="text-lg text-neutral-default">
                {{ lodash.startCase($t("customer_account_receivables.plural")) }}
              </div>
            </div>
          </template>
          <template #before-table>
            <div class="mb-3">
              <hr />
              <div class="row g-3">
                <div class="col-md-6">
                  <day-past-due v-if="chartData" v-model="chartData"></day-past-due>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="text-xl text-default">Piutang Mitra</div>
            </div>
          </template>
        </model-index>
      </div>
    </Loader>
    <b-modal ref="modal" :title="`Piutang dari ${selectedItem.name}`" size="lg" hide-footer>
      <CustomerAccountReceivableForm
        v-model="selectedItem"
        @updated="$refs.table.$refs.table.refresh()"
      ></CustomerAccountReceivableForm>
    </b-modal>
  </div>
</template>
<script>
// import ModelFilter from "@/components/model-filter-v4";
import ModelIndex from "@/router/views/models/index-v3";
import icons from "@/assets/icons";
import DayPastDue from "./../components/day-past-due.vue";
import editable from "@/components/mixins/editable";
import CustomerAccountReceivableForm from "./form";
import DistressStatus from "./distress_status.vue";

export default {
  extends: ModelIndex,
  components: {
    // ModelFilter,
    DayPastDue,
    CustomerAccountReceivableForm
  },
  mixins: [editable],
  props: {
    // cardTitle: {default() { return this.lodash.startCase(this.$t('trips.plural')) }},
    resourceRoute: { default: "customer_account_receivables" },
    modelVariable: { default: "customer_account_receivable" },
    denyCreate: {
      type: Boolean,
      default: true
    },
    hideTableHeader: {
      type: Boolean,
      default: true
    },
    tableMinHeight: {
      type: Number,
      default: 0
    },
    cardAttrs: {
      type: Object,
      default() {
        return {
          bodyClass: "d-flex flex-column"
        };
      }
    },
    queryKey: {
      type: String,
      default: "customer_account_receivables"
    },
    modelKey: {
      type: String,
      default: "customer_name"
    }
  },
  data() {
    return {
      selectedItem: {},
      icons,
      dayUntilDueOptions: [
        { value: "0", text: `0-10 ${this.lodash.startCase(this.$t("units.days"))}` },
        { value: "11", text: `11-21 ${this.lodash.startCase(this.$t("units.days"))}` },
        { value: "21", text: `21-31 ${this.lodash.startCase(this.$t("units.days"))}` },
        { value: "31", text: `31-40 ${this.lodash.startCase(this.$t("units.days"))}` }
      ],
      selectedDayUntilDue: null,
      title: this.lodash.startCase(this.$t("customer_account_receivables.plural")),
      items: [
        {
          text: this.lodash.startCase(this.$t("customer_account_receivables.plural")),
          href: "/customer_account_receivables",
          active: true
        }
      ],
      sortBy: "date",
      sortDesc: true,
      filterColumns: {
        "ticketable.ticket_id__in": {
          type: Array,
          label: this.lodash.upperFirst(this.$t("tickets.ticket_id")),
          operator: "in",
          input_component: "ticket-multiselect-ajax"
        },
        date__between: {
          type: Array,
          label: this.lodash.upperFirst(this.$t("customer_account_receivables.date")),
          operator: "between",
          input_component: "datepicker-range"
        }
      },
      chart: null
    };
  },
  computed: {
    columns() {
      return {
        ["customer_account_receivable"]: [
          {
            key: "index",
            label: "No",
            tdClass: "align-middle"
          },
          {
            key: "name",
            label: this.lodash.startCase(this.$t(`${this.resourceRoute}.customer_name`)),
            tdClass: "align-middle"
          },
          {
            key: "account_receivable",
            label: this.lodash.startCase(this.$t(`${this.resourceRoute}.total`)),
            tdClass: "align-middle text-end text-nowrap",
            formatter: value => {
              return this.$numeral(value).format("$ 0,0");
            }
          },
          {
            key: "account_receivable_not_yet_due",
            label: this.lodash.startCase(this.$t(`${this.resourceRoute}.day_before_due`)),
            tdClass: "align-middle text-end text-nowrap",
            thStyle: "min-width: 60px; text-align: center;",
            formatter: value => {
              return this.$numeral(value).format("$ 0,0");
            }
          },
          {
            key: "account_receivable_gte_1_day_pas_due",
            label: this.lodash.startCase("1-30"),
            tdClass: "align-middle text-end text-nowrap",
            thStyle: "min-width: 60px; text-align: center;",
            formatter: value => {
              return this.$numeral(value).format("$ 0,0");
            }
          },
          {
            key: "account_receivable_gte_31_day_pas_due",
            label: this.lodash.startCase("31-60"),
            tdClass: "align-middle text-end text-nowrap",
            thStyle: "min-width: 60px; text-align: center;",
            formatter: value => {
              return this.$numeral(value).format("$ 0,0");
            }
          },
          {
            key: "account_receivable_gte_61_day_pas_due",
            label: this.lodash.startCase("61-90"),
            tdClass: "align-middle text-end text-nowrap",
            thStyle: "min-width: 60px; text-align: center;",
            formatter: value => {
              return this.$numeral(value).format("$ 0,0");
            }
          },
          {
            key: "account_receivable_gte_91_day_pas_due",
            label: this.lodash.startCase("91-120"),
            tdClass: "align-middle text-end text-nowrap",
            thStyle: "min-width: 60px; text-align: center;",
            formatter: value => {
              return this.$numeral(value).format("$ 0,0");
            }
          },
          {
            key: "account_receivable_gte_121_day_pas_due",
            label: this.lodash.startCase(">121"),
            tdClass: "align-middle text-end text-nowrap",
            thStyle: "min-width: 60px; text-align: center;",
            formatter: value => {
              return this.$numeral(value).format("$ 0,0");
            }
          },
          {
            key: "distress_status",
            label: this.lodash.startCase(this.$t(`${this.resourceRoute}.distress_status`)),
            tdClass: "align-middle",
            component: DistressStatus,
            componentx: {
              props: ["item"],
              mixins: [editable],
              data() {
                return {
                  statuses: ["healthy", "first_warning", "second_warning", "discontinue"],
                  distress_status: this.item.distress_status
                };
              },
              methods: {
                badgeClass(distress_status) {
                  const status = {
                    healthy: "badge-soft-green-500",
                    first_warning: "badge-soft-yellow-500",
                    second_warning: "badge-soft-orange-500",
                    discontinue: "badge-soft-red-500"
                  };
                  return status[distress_status];
                },
                update(value) {
                  // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                  this.distress_status = value.distress_status;
                  return this.$axios.put(`/customer_finance_accounts/${value.customer_finance_account_id}`, {
                    distress_status: value.distress_status
                  });
                }
              },
              template: `     
                <div>
                  <b-dropdown
                    class="card-drop"
                    toggle-class="p-0"
                    menu-class="dropdown-menu-end"
                    variant="link"
                    v-if="!updating"
                  >
                    <template v-slot:button-content>
                      <div :class="['badge rounded-pill', badgeClass(distress_status)]">
                        {{$t("customer_account_receivables.distress_statuses."+distress_status)}}                      
                        <i class="mdi mdi-chevron-down"></i>
                      </div>
                    </template>
                    <slot name="action" v-bind="{ data }">
                      <b-dropdown-item
                        v-for="status in statuses"
                        :key="status"
                        @clickx="$emit('distress-status-selected', item, status)"
                        @click="handleUpdate({...item, distress_status: status})"
                      >
                        <div :class="['badge rounded-pill', badgeClass(status)]">
                          {{$t("customer_account_receivables.distress_statuses."+status)}}
                        </div>
                      </b-dropdown-item>
                    </slot>
                  </b-dropdown>
                  <i v-else class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                </div>           
              `
            }
            // componentListeners: {
            //   "distress-status-selected": (item, distress_status) => {
            //     window.console.log("distress status selected", this);
            //     this.handleUpdate({ ...item, distress_status });
            //   }
            // }
          }
        ]
      };
    }
  },
  methods: {
    handleShow(value) {
      this.selectedItem = value;
      this.$refs.modal.show();
    },
    requestConfig(page = 1) {
      return {
        params: {
          page: page,
          per_page: this.perPage,
          search: this.search,
          sort: `${this.sortBy},${this.sortDesc ? "desc" : "asc"}`,
          ...this.filterParams
        }
      };
    },
    dummyFetch() {
      return new Promise(resolve => {
        setTimeout(() => {
          const data = [
            {
              total: 100000,
              day_before_due: 100000,
              day_past_due_1: 25000000,
              day_past_due_31: 25000000,
              day_past_due_61: 25000000,
              day_past_due_91: 25000000,
              day_past_due_121: 25000000,
              customer: {
                distress_status: "Aman",
                name: "CV Raisa"
              }
            },
            {
              total: 100000,
              day_before_due: 100000,
              day_past_due_1: 25000000,
              day_past_due_31: 25000000,
              day_past_due_61: 25000000,
              day_past_due_91: 25000000,
              day_past_due_121: 25000000,
              customer: {
                distress_status: "SP I",
                name: "blabla"
              }
            },
            {
              total: 100000,
              day_before_due: 100000,
              day_past_due_1: 25000000,
              day_past_due_31: 25000000,
              day_past_due_61: 25000000,
              day_past_due_91: 25000000,
              day_past_due_121: 25000000,
              customer: {
                distress_status: "SP II",
                name: "Amboja"
              }
            },
            {
              total: 100000,
              day_before_due: 100000,
              day_past_due_1: 25000000,
              day_past_due_31: 25000000,
              day_past_due_61: 25000000,
              day_past_due_91: 25000000,
              day_past_due_121: 25000000,
              customer: {
                distress_status: "DC",
                name: "Kingdom"
              }
            }
          ];
          data.forEach(item => {
            item.day_until_due = this.$moment(item.date).diff(this.$moment(), "days");
          });
          resolve({
            data: {
              data,
              meta: {
                current_page: 1,
                from: 1,
                last_page: 280,
                per_page: "10",
                to: 10,
                total: 2796
              }
            }
          });
        }, 5000);
      });
    },
    fetchModels(page = 1) {
      this.loading = true;
      page = this.page || page;
      return this.$axios
        .get(`/customer_account_receivables?ticket_id__eq=${this.$route.params.key}`, this.requestConfig(page))
        .then(this.handleResponse)
        .catch(error => {
          this.failedAlert(error);
          return null;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleResponse(response) {
      const {
        data: { data, meta }
      } = response;
      this.models = data;
      this.page = Number(meta.current_page);
      this.perPage = Number(meta.per_page);
      this.from = Number(meta.from);
      this.total = Number(meta.total);
      this.chartData = meta;

      this.stats = [];

      return response;
    },
    update(value) {
      return this.$axios.put(`/customer_finance_accounts/${value.customer_finance_account_id}`, {
        distress_status: value.distress_status
      });
    },
    updated() {
      this.fetchModels().then(() => {
        this.$refs.table.$refs.table.refresh();
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/design/app";

::v-deep {
  .table-model {
    @extend .jds-table;
    table {
      @extend .table-zebra;
      @extend .table-borderless;
    }
    overflow: auto;
  }
}
</style>
